module.exports = __webpack_public_path__ + "static/WS_appflows_virtual_5-2c19d8d6954d22b0b64d4cfb2030e56f.gif";